import { render, staticRenderFns } from "./TextVideoFullWidth.vue?vue&type=template&id=38f1fc3c&"
import script from "./TextVideoFullWidth.vue?vue&type=script&lang=js&"
export * from "./TextVideoFullWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports